var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sportbook","data-bto-app":""}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('svg',{staticStyle:{"max-width":"100%"},attrs:{"id":"barcode"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }